import React from "react";
import { APP_NAME } from "../constants/app";
import { PrivateRoute, PublicRoute } from "./routeHelpers";
import { BrowserRouter, Switch, Redirect, Route } from "react-router-dom";
import { enableContext } from "../auth/secret";

import Static from "../views/Static/home";
import Users from "../views/Users";
import App from "../views/apps";
import DeleteUserRequest from "../static/DeleteUserRequest";
import TermAndCondition from "../static/TermAndCondition";
import PrivacyPolicy from "../static/PrivacyPolicy";

export default function index() {
  return (
    <BrowserRouter basename={enableContext ? `/${APP_NAME}` : undefined}>
      <Switch>
        <Route path="/delete-user-request" component={DeleteUserRequest} />
        <Route path="/term-and-condition" component={TermAndCondition} />
        <Route path="/privacy-policy" component={PrivacyPolicy} />
        <Route path="/home" component={Static} />
        <PublicRoute path={`/auth`} component={Users} />
        <PrivateRoute path={`/app`} component={App} />
        <Redirect to="/auth/login" />
      </Switch>
    </BrowserRouter>
  );
}
